import React, {useEffect, useState} from 'react'
import CreatableSelect from 'react-select/creatable'
import {MultiValue, ActionMeta} from 'react-select'
import {FormikValues} from 'formik'
import {ISelectOption} from '../../../utils/core/_model'

type Props = {
  options: ISelectOption[]
  formik: FormikValues
  fieldname: string
  onSelect: (selected: ISelectOption[]) => void
}

const MultiSelectWithDefault = ({options, formik, fieldname, onSelect}: Props) => {
  const [selectedOptions, setSelectedOptions] = useState<ISelectOption[]>([])

  // Handle selection changes properly
  const handleChange = (
    selected: MultiValue<ISelectOption>,
    actionMeta: ActionMeta<ISelectOption>
  ) => {
    const updatedSelection = selected ? (selected as ISelectOption[]) : []
    setSelectedOptions(updatedSelection)
    onSelect(updatedSelection)
  }

  // Handle new option creation
  const handleCreate = (inputValue: string) => {
    const newOption: ISelectOption = {
      id: Date.now(), // Unique ID
      value: inputValue,
      label: inputValue,
    }

    const updatedSelection = [...selectedOptions, newOption]
    setSelectedOptions(updatedSelection)
    onSelect(updatedSelection)
  }

  // Sync with formik values on mount & update
  useEffect(() => {
    if (formik.values[fieldname].length > 0) {
      const selected = formik.values[fieldname].map((email: string, idx: number) => ({
        id: idx + 1,
        value: email,
        label: email,
      }))
      setSelectedOptions(selected)
      console.log(formik.values[fieldname])
    } else {
      setSelectedOptions([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values[fieldname], fieldname])

  return (
    <div>
      <CreatableSelect
        isMulti
        className='react-select-styled react-select custom-input w-100'
        classNamePrefix='react-select'
        options={options} // Do not mix `selectedOptions` here
        value={selectedOptions}
        onChange={handleChange}
        onCreateOption={handleCreate}
        placeholder='Type and press enter...'
        noOptionsMessage={() => 'Type to add'}
        formatCreateLabel={(inputValue) => `Press Enter to add "${inputValue}"`}
      />
    </div>
  )
}

export default MultiSelectWithDefault
